import React from 'react';

interface GoogleMapProps {
  address: string;
}

const GoogleMap: React.FC<GoogleMapProps> = ({ address }) => {
  // Use the Maps Embed API with the provided API key
  const apiKey = "AIzaSyCDoCnQobyfVVyeSLU3hBT-wbVflmInZls";
  // Exact location of Beta Kalıp Dizayn Tasarım
  const location = "Beta Kalıp Dizayn Tasarım, Çobançeşme, Mithatpaşa Cd., 34196 Bahçelievler/İstanbul";
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(location)}&zoom=17`;

  return (
    <div className="w-full h-full">
      <iframe
        title="Google Map"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0 }}
        src={mapUrl}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

export default GoogleMap; 